export default{
    namespaced:true,
    state:{
        breadcrumbs:[],
    },
    mutations:{
        CREATE_BREADCRUMBS(state,breadcrumbs){
         //  state.breadcrumbs = [];       
           state.breadcrumbs = breadcrumbs;
        },
        CLEAR_BREADCRUMBS(state){
            state.breadcrumbs = [];
        }
    },
    getters:{
        breadcrumbs(state){
            return state.breadcrumbs;
        }
    }
}


// WEBPACK FOOTER //
// ./resources/js/store/breadcrumbs.js